import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import ArrowUpIcon from '@/assets/svg/arrow_up.svg';
import { colors } from '@/constants/theme';
import { scrollToTop } from '@/utils/scroll';

function ScrollBackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }

    window.addEventListener('scroll', onScroll, false);

    return () => {
      window.removeEventListener('scroll', onScroll, false);
    };
  }, []);

  return (
    <Component isVisible={isVisible} onClick={() => scrollToTop()}>
      <ArrowUpIcon />
    </Component>
  );
}

export default ScrollBackToTopButton;

const Component = styled.div<{ isVisible?: boolean }>`
  position: fixed;
  right: 25px;
  bottom: 175px;
  z-index: 101;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  width: 46px;
  height: 46px;
  background-color: ${(props) => props.theme.white_1};
  border: 1px solid ${colors.gray400};
  border-radius: 100%;

  opacity: 0;
  visibility: hidden;
  transition: all 0.25s ease-in-out;

  ${({ isVisible }) =>
    isVisible &&
    css`
      opacity: 1;
      visibility: visible;
    `};

  svg {
    fill: ${(props) => props.theme.main};
  }

  @media (min-width: 1200px) {
    right: 57px;
    bottom: 130px;

    width: 56px;
    height: 56px;
  }
`;
